// Create a new conversation: browse the org directory, or create a group/channel.
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import Directory from '../widgets/directory.jsx';
import NewTopicGroup from '../widgets/new-topic-group.jsx';

import HashNavigation from '../lib/navigation.js';
import { theCard } from '../lib/utils.js';

class NewTopicView extends React.Component {
  constructor(props) {
    super(props);

    const urlParams = HashNavigation.parseUrlHash(window.location.hash).params;
    this.state = {
      tabSelected: urlParams['tab'] === 'grp' ? 'grp' : 'dir'
    };

    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleNewGroupSubmit = this.handleNewGroupSubmit.bind(this);
    this.handleDirectorySelect = this.handleDirectorySelect.bind(this);
  }

  componentDidMount() {
    if (this.props.onInitFind) { this.props.onInitFind(); }
  }

  handleTabClick(e) {
    e.preventDefault();
    const id = e.currentTarget.dataset.id;
    // Switch tabs on a CLEAN new-topic hash: keep only the panel + the tab param,
    // dropping any leftover topic uid in the path (which would otherwise be read as
    // "open that chat" and hijack the tab switch).
    const panel = HashNavigation.parseUrlHash(window.location.hash).path[0] || 'newtpk';
    HashNavigation.navigateTo(HashNavigation.composeUrlHash([panel], {tab: id}));
    this.setState({tabSelected: id});
  }

  handleDirectorySelect(uid) {
    HashNavigation.navigateTo(HashNavigation.removeUrlParams(window.location.hash, ['tab', 'q']));
    this.props.onCreateTopic(uid);
  }

  handleNewGroupSubmit(name, description, dataUrl, priv, tags, isChannel) {
    HashNavigation.navigateTo(HashNavigation.removeUrlParams(window.location.hash, ['tab', 'q']));
    this.props.onCreateTopic(undefined,
      {public: theCard(name, dataUrl, null, description), private: priv, tags: tags}, isChannel);
  }

  render() {
    return (
      <div className="flex-column">
        <ul className="tabbar">
          <li className={this.state.tabSelected === 'dir' ? 'active' : null}>
            <a href="#" data-id="dir" onClick={this.handleTabClick}>
              <FormattedMessage id="tabtitle_directory" defaultMessage="directory"
                description="Tab title Org directory" />
            </a>
          </li>
          <li className={this.state.tabSelected === 'grp' ? 'active' : null}>
            <a href="#" data-id="grp" onClick={this.handleTabClick}>
              <FormattedMessage id="tabtitle_new_group" defaultMessage="new group"
                description="Tab title New Group" />
            </a>
          </li>
        </ul>
        {this.state.tabSelected === 'grp' ?
          <NewTopicGroup
            tinode={this.props.tinode}
            onSubmit={this.handleNewGroupSubmit}
            onError={this.props.onError} /> :
          <Directory
            tinode={this.props.tinode}
            onSelect={this.handleDirectorySelect} />}
      </div>
    );
  }
};

export default injectIntl(NewTopicView);
